module.exports = __webpack_public_path__ + "static/media/035.eaad9c61.jpg";